import { Injectable } from "@angular/core";
import { Database } from './../database';
import 'rxjs/add/operator/map';
@Injectable()
export class BLLViewCariler extends Database{
    eklenecek_carikartlariview=[];
    guncellencek_carikartlariview=[];

    constructor(){
        super("Vw_Cariler");
    }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-viewCariler.ts